/* eslint-disable no-self-assign */
import userGroup from '@/api/userGroup'
import get from 'lodash/get'

const INITIAL_STATE = {
  userGroupsName: [],
  userGroupList: {},
  userGroupData: {},
}

export default {
  namespace: 'userGroup',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setUserGroupsName(state, { payload }) {
      return { ...state, userGroupsName: payload }
    },
    setUserGroupList(state, { payload }) {
      return { ...state, userGroupList: payload }
    },
    setUserGroupData(state, { payload }) {
      return { ...state, userGroupList: payload }
    },
  },

  effects: {
    *getUserGroupsByName({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.getUserGroupsByName, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { data, success } = resData

        if (success) {
          hasError = false

          yield put({ type: 'userGroup/setUserGroupsName', payload: data })
          successCallback?.(data || [])
        }
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getUserGroups({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.getUserGroups, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'userGroup/setUserGroupList', payload: resData })
        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getUserGroup({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.getUserGroup, {
        ...payload,
        params: { accountId: get(account, 'accountId'), ...payload },
      })

      const { status, data: resData } = response

      let error = {}

      if (status === 200) {
        const { data } = resData
        error = null
        successCallback?.(data)
      }

      if (error) {
        errorCallback?.(error)
      }
    },

    *createUserGroup({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.createUserGroup, {
        ...payload,
        accountId: get(account, 'accountId'),
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *deleteUserGroup({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.deleteUserGroup, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *uploadFile({ payload, params, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.uploadFile, {
        data: payload,
        params: { accountId: get(account, 'accountId'), ...params },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *uploadFileFinal({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(userGroup.uploadFileFinal, {
        params: { accountId: get(account, 'accountId'), ...payload },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *checkUploadStatus({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(userGroup.checkUploadStatus, {
        params: { accountId: get(account, 'accountId'), ...payload },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *checkFile({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.checkFile, {
        ...payload,
        accountId: get(account, 'accountId'),
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getUploadSucDetail({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.getUploadSucDetail, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getUploadErrDetail({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.getUploadErrDetail, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *userGroupDownload({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.userGroupDownload, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = {}

      if (status === 200) {
        error = null
        successCallback?.(resData)
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getAddableUsers({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { groupId, ...params } = payload
      const response = yield call(userGroup.getAddableUsers, {
        groupId,
        params: { accountId: get(account, 'accountId'), ...params },
      })

      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *addUsersToUserGroup({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(userGroup.addUsersToUserGroup, {
        ...payload,
        accountId: get(account, 'accountId'),
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },
  },
}
